import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function LowRiskIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 50, 50);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      {...a11y}
      {...rest}
      width={width}
      height={height}
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.0322 1C23.9379 1.00016 25.4901 2.53917 25.4902 4.44727C25.4902 5.60301 24.9189 6.61901 24.0488 7.24316L24.1348 7.64551C32.5067 8.69877 37.2517 13.3482 41.7432 19.6016C42.4119 20.5327 42.8434 21.6431 42.9492 22.8457C43.0171 23.6176 43.0171 24.4371 42.9492 25.209C42.8434 26.4113 42.4117 27.5203 41.7432 28.4512C36.3754 35.9236 30.3453 38.2816 22.6826 41.9658L21.1279 42.7227C20.1231 43.2181 18.8694 42.5191 18.8691 41.3311V41.1016L18.9688 40.8955L19.9551 38.8555C16.1862 38.6636 13.0619 37.7693 10.3271 36.1885C7.23092 34.3987 4.70433 31.7707 2.32031 28.4512C1.42192 27.2 1.00129 25.5913 1 24.0322C0.998768 22.4731 1.41691 20.8609 2.32031 19.6025C6.81176 13.3478 11.5554 8.69955 19.9277 7.64551L20.0127 7.24316C19.1435 6.61874 18.5732 5.60213 18.5732 4.44727C18.5733 2.53908 20.1264 1 22.0322 1Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M24.7032 26.5986C24.9249 26.4347 25.238 26.4807 25.4024 26.7021C25.5663 26.9238 25.5201 27.2369 25.2989 27.4014C23.3222 28.8654 20.68 28.8656 18.7032 27.4014C18.4816 27.2369 18.4354 26.9239 18.5996 26.7021C18.7642 26.4808 19.0772 26.4344 19.2989 26.5986C20.9218 27.8005 23.0802 27.8005 24.7032 26.5986Z"
        fill="#91C000"
      />
      <path
        d="M17.9571 19.374C18.8622 19.3741 19.5956 20.1854 19.5957 21.1865V23C19.5956 24.0011 18.8622 24.8125 17.9571 24.8125C17.052 24.8125 16.3186 24.0011 16.3184 23V21.1865C16.3185 20.1854 17.0519 19.3741 17.9571 19.374Z"
        fill="#91C000"
      />
      <path
        d="M26.1065 19.374C27.0117 19.374 27.746 20.1854 27.7461 21.1865V23C27.746 24.0011 27.0116 24.8125 26.1065 24.8125C25.2016 24.8122 24.468 24.0009 24.4678 23V21.1865C24.4679 20.1856 25.2015 19.3743 26.1065 19.374Z"
        fill="#91C000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0323 2C23.3899 2.00016 24.4902 3.09576 24.4903 4.44727C24.4903 5.48775 23.8377 6.37537 22.918 6.72949L23.3057 8.55762C31.7177 9.38544 36.3807 13.8507 40.9307 20.1855C41.4984 20.976 41.8636 21.9151 41.9532 22.9326C42.0159 23.6463 42.0159 24.4074 41.9532 25.1211C41.8636 26.1387 41.4984 27.0778 40.9307 27.8682C35.3872 35.5852 29.2058 37.622 20.6856 41.8252C20.3142 42.0083 19.8695 41.7436 19.8692 41.3311L21.5313 37.8955C12.8444 37.8955 7.80754 34.3772 3.13285 27.8682C1.627 25.7713 1.61777 22.2957 3.13285 20.1855C7.68282 13.8494 12.3447 9.38619 20.7579 8.55762L21.1446 6.72949C20.2255 6.37507 19.5733 5.48732 19.5733 4.44727C19.5734 3.09568 20.6745 2.00003 22.0323 2ZM35.3477 26.4512C37.5814 9.55867 6.57723 10.2766 8.71586 26.4512C9.20002 30.1119 12.0941 31.3315 15.7715 31.8135C19.7196 32.3309 24.3157 32.3346 28.292 31.8135C31.9696 31.3315 34.8635 30.112 35.3477 26.4512Z"
        fill="#91C000"
      />
    </svg>
  );
}

export default LowRiskIcon;
